import React from "react";

const ActivitiesButtonTitle = ({ title }) => {
  return (
    <div className="mb-6">
      <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 pb-3 border-b border-blue-600">
        {title}
      </h2>
    </div>
  );
};

export default ActivitiesButtonTitle;
